module.exports = __webpack_public_path__ + "static/media/profile.32232401.svg";